module.exports = __webpack_public_path__ + "media/images/emblems/Brenzikofen-coat_of_arms-f95787a690b89baa7e11e4103df54171.svg";